var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvas',{ref:"canvas",attrs:{"id":"canvas","width":1180 * _vm.multiple,"height":600 * _vm.multiple}})}
var staticRenderFns = []

export { render, staticRenderFns }